/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.schools.school-board'},
});

const SchoolBoardItem = () => (
  <RouteLinkItem
    route="midas/settings/schools/school-board"
    title={messages.title}
  />
);

export default SchoolBoardItem;
